import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/common/sharedServices/user/user.service';
import { FileOpenerService } from 'src/app/common/sharedServices/files/file-opener.service';
import { DateUtility } from 'src/app/common/utilities/DateUtils';
import { Base64DocumentodResponse, TestataIntervento } from 'src/app/common/models/Intervento';
import { AppUser } from 'src/app/common/models/Utente';
import { lastValueFrom } from 'rxjs';
import { PDFDocument } from 'pdf-lib';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from 'src/app/common/sharedServices/preferences/preferences.service';

@Injectable({
  providedIn: 'root'
})
export class PdfInterventiService {
  private readonly GET_BASE64_DOCUMENTO_ROUTE = '/immto_wsr_stampa_doc';

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private fileOpener: FileOpenerService,
    private translate: TranslateService,
    protected preferenzeService: PreferencesService,
  ) { }

  getFileName(intervento: TestataIntervento): string {
    const data = new Date();
    const dataStr = DateUtility.generateIsoShortDateString(data);
    let fileName = `${intervento.ragioneSociale}_${dataStr}.pdf`;
    while (fileName.includes(' ')) {
      fileName = fileName.replace(' ', '');
    }
    return fileName;
  }

  async openReportPdf(intervento: TestataIntervento, pdfContentB64: string) {
    const nomeFile = this.getFileName(intervento);
    const mimeType = 'application/pdf';
    await this.fileOpener.openFile(pdfContentB64, nomeFile, mimeType);
  }

  async getPdfFirmato(idIntervento: number, tipoReportScelto: string, firmaChiusuraClienteBlob: string): Promise<string>{
    const userData = await this.userService.getDatiUtente();
    const base64Documento = await this.getBase64Documento(userData, idIntervento, tipoReportScelto);

    if (base64Documento != ''){
      //Ottengo bytes della documento originale
      const bytesDocumento = Uint8Array.from(atob(base64Documento), c => c.charCodeAt(0));    
      //Creo un nuovo documento PDF a partire dal contenuto decodificato
      const pdfDoc = await PDFDocument.load(bytesDocumento);
      //Ottengo bytes della firma
      const base64Firma = firmaChiusuraClienteBlob.replace(/^data:.*?;base64,/,'');
      const bytesFirma = Uint8Array.from(atob(base64Firma), c => c.charCodeAt(0));
      
      //Creo un 'pdf' dell'immagine
      const pdfFirma = await pdfDoc.embedPng(bytesFirma);

      //Get preferenze utente per ottenere coordinate firma
      const preferenze = await this.preferenzeService.getPreferenzeUtente();
      
      //Aggiungo la firma sull'ultima pagina del pdf
      const pages = pdfDoc.getPages();
      const lastPage = pages[pages.length - 1];
      lastPage.drawImage(pdfFirma, {
        x: preferenze.COORDINATE_FIRMA.x,
        y: preferenze.COORDINATE_FIRMA.y,
        width: 130, // larghezza dell'immagine PNG
        height: 50, // altezza dell'immagine PNG
      });

      const pdfBase64 = await pdfDoc.saveAsBase64();

      /**
       * Codice per aprire il pdf in una scheda
       */
      // const bytesPdf = Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0));
      // const blob = new Blob([bytesPdf], { type: 'application/pdf' });
      // const url = URL.createObjectURL(blob);
      // window.open(url, '_blank');
      
      return pdfBase64;
    }
    else
      return '';    
  }

  async getBase64Documento(userData: AppUser, idIntervento: number, tipoReportScelto: string): Promise<string>{
    const completeUrl = `${userData.server}${this.GET_BASE64_DOCUMENTO_ROUTE}`;
    
    const body = {
      aziCdazi: userData.aziCdazi,
      token: userData.token,
      siglaAddetto: userData.putSigla,
      idIntervento: idIntervento,
      chiaveSecondaria: 0,
      tipoReportIntervento: tipoReportScelto
    };

    const response = await lastValueFrom(this.http.post<Base64DocumentodResponse>(completeUrl,body));
    if (response && response.st == 0)
      return response.filebase64
    else
      throw new Error(this.translate.instant(`Operations.pdfFetchDocumentError: stato errore ${response.st}`));
  }
}